import React, { createContext, useContext } from 'react';
var defaultLinkEmbedProps = {
  linkEmbeds: [],
  linkRichEmbeds: [],
  atEmbeds: []
};
export var LinkEmbedsContext = createContext(defaultLinkEmbedProps);
export var LinkEmbedsProvider = function (_a) {
  var linkEmbeds = _a.linkEmbeds,
    atEmbeds = _a.atEmbeds,
    linkRichEmbeds = _a.linkRichEmbeds,
    children = _a.children;
  return React.createElement(LinkEmbedsContext.Provider, {
    value: {
      linkEmbeds: linkEmbeds,
      linkRichEmbeds: linkRichEmbeds,
      atEmbeds: atEmbeds
    }
  }, children);
};
export var useLinkEmbeds = function () {
  return useContext(LinkEmbedsContext);
};
export default LinkEmbedsContext;